import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.99997C11 8.44769 11.4477 7.99997 12 7.99997C12.5523 7.99997 13 8.44769 13 8.99997V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8.99997Z M12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16Z M 11.2929,1.70708 c 0.3905,-0.39053 1.0237,-0.39053 1.4142,0 l 9.5858,9.58582 c 0.3905,0.3905 0.3905,1.0237 0,1.4142 l -9.5858,9.5858 c -0.3905,0.3905 -1.0237,0.3905 -1.4142,0 L 1.70714,12.7071 c -0.39053,-0.3905 -0.39053,-1.0237 0,-1.4142 z M 12,20.1715 20.1716,12 12,3.8284 3.82846,12 Z"
  }));
});
var NotificationAlert = AbstractIcon.withComponent(Icon);
NotificationAlert.displayName = 'NotificationAlert';
export default NotificationAlert;